import React, { useState } from 'react';
import DeltaShape from '../../propTypes/DeltaShape';
import deltaOnlyContainWhitespace from '../../utils/deltaOnlyContainWhitespace';
import EditingOrganizationSummary from './EditingOrganizationSummary';
import styles from './OrganizationSummary.module.scss';
import ReadonlyOrganizationSummary from './ReadonlyOrganizationSummary';

const DEFAULT_VALUES = [{ insert: '\n\n' }];

const propTypes = {
  summary: DeltaShape,
};

const defaultProps = {
  summary: null,
};

const OrganizationSummary = ({ summary }) => {
  const [isEditing, setIsEditing] = useState(false);
  const isSummaryEmpty = !summary || deltaOnlyContainWhitespace(summary);

  return (
    <header className={styles.container} aria-label="Organization Summary">
      {isEditing ? (
        <EditingOrganizationSummary
          summary={
            isSummaryEmpty
              ? DEFAULT_VALUES // Show at least two lines so user can see the placeholder
              : summary
          }
          onCancelEditing={() => setIsEditing(false)}
        />
      ) : (
        <ReadonlyOrganizationSummary
          summary={isSummaryEmpty ? null : summary}
          onStartEditing={() => setIsEditing(true)}
        />
      )}
    </header>
  );
};

OrganizationSummary.propTypes = propTypes;
OrganizationSummary.defaultProps = defaultProps;

export default OrganizationSummary;
